module.exports = __webpack_public_path__ + "assets/img/title-d144ec2c.png";